'use client';

import { createGoogleAnalyticsService } from '@kit/google-analytics';
import { createPostHogAnalyticsService } from '@kit/posthog';

import { createAnalyticsManager } from './analytics-manager';
import type { AnalyticsManager } from './types';

// Lazy initialization to avoid Turbopack eval context issues
let _analytics: AnalyticsManager | null = null;

function getAnalytics(): AnalyticsManager {
  if (!_analytics) {
    _analytics = createAnalyticsManager({
      providers: {
        posthog: createPostHogAnalyticsService,
        'google-analytics': createGoogleAnalyticsService,
      },
    });
  }
  return _analytics;
}

export const analytics: AnalyticsManager = {
  addProvider: (...args) => getAnalytics().addProvider(...args),
  removeProvider: (...args) => getAnalytics().removeProvider(...args),
  identify: (...args) => getAnalytics().identify(...args),
  trackPageView: (...args) => getAnalytics().trackPageView(...args),
  trackEvent: (...args) => getAnalytics().trackEvent(...args),
};
